import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  Stack,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";


const AoReasonForm = () => {
  const [aoReasonName, setAoReasonName] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [imgReqd, setImgReqd] = useState(false);
  const [posReqd, setPosReqd] = useState(false);
  const [subCat, setSubCat] = useState([]);
  const [subInput, setSubInput] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [editData, setEditData] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [hideDelete, setHideDelete] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);

  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ports}`;
  const aoRoReasonsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.aoRoReasons}`;

  const handleSubmit = async () => {
    const model = {
      reason: aoReasonName,
      subReasons: subCat,
      postnNumReqd: posReqd,
      imgUpldReqd: imgReqd,
    };
    if (aoReasonName) {
      try {
        if (params.id) {
          await OAuthService.updateData(aoRoReasonsUrl, params.id, model);
          setSuccessMsg("Data Updated Successfully");
          setSnackState(true);
        } else {
          await OAuthService.addData(aoRoReasonsUrl, model);
          setSuccessMsg("Data saved Successfully");
          setSnackState(true);
        }
      } catch (error) {
        setError(
          error?.response?.data?.errorMessage ||
            error?.response?.data ||
            error.message,
        );
        return;
      }
      setTimeout(() => {
        navigate("/aoReason");
      }, 800);
    }
  };

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  const editPort = async () => {
    try {
      const result = await OAuthService.getEditData(aoRoReasonsUrl, params.id);
      const aoReason = result.data;

      setAoReasonName(aoReason?.reason || "");
      setImgReqd(!!aoReason?.imgUpldReqd);
      setPosReqd(!!aoReason?.postnNumReqd);
      setSubCat(aoReason?.subReasons || []);
      setEditData(aoReason);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (params.id) {
      editPort();
      setHideDelete(false);
    }
  }, []);

  useEffect(() => {
    if (!aoReasonName) {
      setSaveDisable(true);
      return;
    }
    if (!editData) {
      setSaveDisable(false);
      return;
    }
    const oldSubs = [...(editData.subReasons || [])].sort();
    const newSubs = [...subCat].sort();
    const subsChanged =
      oldSubs.length !== newSubs.length ||
      oldSubs.some((v, i) => v !== newSubs[i]);

    const changed =
      aoReasonName !== editData.reason ||
      subsChanged ||
      !!imgReqd !== !!editData.imgUpldReqd ||
      !!posReqd !== !!editData.postnNumReqd;

    setSaveDisable(!changed);
  }, [aoReasonName, subCat, imgReqd, posReqd, editData]);

  

  const handleCreateSubCat = (inputValue) => {
    const newValue = inputValue.trim();
    if (!newValue) return;

    const exists = subCat.some(
      (v) => v.toLowerCase() === newValue.toLowerCase(),
    );
    if (exists) return;

    setSubCat((prev) => [...prev, newValue]);
  };

  const handleCancel = () => {
    navigate("/aoReason");
  };

  return (
    <div className="w-full overflow-scroll">
      <FormPageHeader
        componentName="AO Reasons"
        handleSubmit={handleSubmit}
        breadCrumbSeperator=">"
        currentPage={params.id ? "Update AO Reason" : "Add AO Reason"}
        parentBreadcrumbData={[
          { pageName: "AO Reason List", pageLink: "/aoReason" },
        ]}
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        hideDelete={hideDelete}
        handleCancel={handleCancel}
        saveDisable={saveDisable}
      >
        <Tabs
          value={tabValue}
          textColor="inherit"
          onChange={handleTabChange}
          indicatorColor="secondary"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
        >
          <Tab
            label="General"
            sx={{
              color: "text.secondary",
              "&.Mui-selected": { color: "text.primary" },
            }}
          />
        </Tabs>
      </FormPageHeader>
      <div className="p-16 sm:p-24 max-w-3xl">
        <FormControl className="flex flex-col justify-center">
          <div className={tabValue !== 0 ? "hidden" : ""}>
            <Stack>
              <label>AO Reason</label>
              <TextField
                className="mb-16"
                type="text"
                name="aoReasonName"
                value={aoReasonName}
                disabled={!!params?.id}
                required
                onChange={(e) => setAoReasonName(e.target.value)}
                variant="outlined"
                InputLabelProps={{ shrink: !!aoReasonName }}
              />
            </Stack>

            <Grid container flex justifyContent={"space-between"}>
              <Grid>
                <FormControlLabel
                  value={imgReqd}
                  className="mb-16"
                  name="imgReqd"
                  control={<Switch color="success" />}
                  label="Img Required"
                  labelPlacement="start"
                  onChange={(e) => setImgReqd(e.target.checked)}
                  checked={!!imgReqd}
                />
                <FormControlLabel
                  value={posReqd}
                  className="mb-16"
                  name="posReqd"
                  control={<Switch color="success" />}
                  label="POS Required"
                  labelPlacement="start"
                  onChange={(e) => setPosReqd(e.target.checked)}
                  checked={!!posReqd}
                />
              </Grid>
            </Grid>

            <Stack className="mb-16">
              <label>Sub Categories</label>
              <Stack direction="row" spacing={1} className="mb-8">
                <TextField
                  size="small"
                  fullWidth
                  value={subInput}
                  placeholder="Type a sub category and press Enter..."
                  onChange={(e) => setSubInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleCreateSubCat(subInput);
                      setSubInput("");
                    }
                  }}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={!subInput.trim()}
                  onClick={() => {
                    handleCreateSubCat(subInput);
                    setSubInput("");
                  }}
                >
                  Add
                </Button>
              </Stack>

              <Box
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 1,
                  p: 1,
                  minHeight: 56,
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                  gap: 1,
                }}
              >
                {subCat.length === 0 ? (
                  <Typography variant="body2" color="text.secondary">
                    No sub categories added
                  </Typography>
                ) : (
                  subCat.map((sub) => (
                    <Chip
                      key={sub}
                      label={sub}
                      onDelete={() =>
                        setSubCat((prev) => prev.filter((v) => v !== sub))
                      }
                    />
                  ))
                )}
              </Box>

              {subCat.length > 0 && (
                <Button
                  size="small"
                  color="secondary"
                  sx={{ alignSelf: "flex-start", mt: 0.5 }}
                  onClick={() => setSubCat([])}
                >
                  Clear all
                </Button>
              )}
            </Stack>
          </div>
        </FormControl>
      </div>
    </div>
  );
};

export default AoReasonForm;
